import { useTranslation } from "react-i18next";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";

function BemessungswertDerSchwinggrenze({ upperLower }) {
  const { t } = useTranslation("translation");
  const F_d_delta_sigma_Formula = `\\displaystyle F_{d, \\Delta\\sigma} = \\frac{F_{k,O} - F_{k,U}}{\\gamma_{\\tiny _{Ff}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.oscillationLimit")}</p>}
      formulaValue={
        <ToolTip
          id={"F_d_delta_sigma_Formula"}
          type={IconType.FORMULA}
          formula={F_d_delta_sigma_Formula}
        />
      }
      indicesValue={
        <span>
          F<sub>d,Δσ</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={upperLower} />
        </span>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default BemessungswertDerSchwinggrenze;
